// extracted by mini-css-extract-plugin
module.exports = {"main_nav":"main_nav-21NYiaB_","box":"box-2xJTjLUM","ad":"ad-20wYiP5i","search":"search-23p2h17E","logo":"logo-2RYPgTBi","userinfo":"userinfo-3oDsrH5I"};